export default __webpack_public_path__ + "static/media/user_avatar.ac2d02c0.svg";